<template>
  <div>
    <div class="gray-bg">
      <main-header/>
    </div>
    <div v-if="isLoaded">
      <div v-if="allProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products :productsArray="allProducts" :page-title="pageTitle"/>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import MainHeader from "./mainHeader";
import MoreProducts from "./moreProducts";

export default {
  name: "allProducts",
  components: {MainHeader, MoreProducts},
  metaInfo() {
    return {
      title: window.projectName + this.pageTitle,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.pageTitle,
          vmid: 'og:title'
        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.pageTitle,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    allProducts: [],
    isLoaded: false,
    showLoaderDialog: false,
    pageTitle: "همه محصولات"
  }),
  mounted() {

    this.getData();
    if (this.$route.query.isSeasonalProduct) {
      this.pageTitle = "محصولات فصلی"
    } else if (this.$route.query.isVip) {
      this.pageTitle = "محصولات ویژه"
    } else if (this.$route.query.isNewProduct) {
      this.pageTitle = "محصولات جدید"
    } else if (this.$route.query.isDiscounted) {
      this.pageTitle = "محصولات تخفیف دار"
    } else {
      this.pageTitle = "همه محصولات"
    }
  },
  watch: {
    '$route.query'() {
      location.reload()
    }
  },
  methods: {
    getData() {
      this.showLoaderDialog = true;

      let urlencoded = new URLSearchParams();

      if (this.$route.query.isVip)
        urlencoded.append("isVip", this.$route.query.isVip);

      if (this.$route.query.isNewProduct)
        urlencoded.append("isNewProduct", this.$route.query.isNewProduct);

      if (this.$route.query.isSeasonalProduct)
        urlencoded.append("isSeasonalProduct", this.$route.query.isSeasonalProduct);

      if (this.$route.query.isDiscounted)
        urlencoded.append("hasDiscount", this.$route.query.isDiscounted);

      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        body: urlencoded
      };

      fetch(this.$baseUrl + "/SearchEngine/FilterProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
                this.allProducts = JSON.parse(result)
                this.isLoaded = true
                this.showLoaderDialog = false
              }
          )
          .catch(error => console.log('error', error));
    },
  },
}
</script>

